export type IdentitySeedKey =
  | 'ShipmentId'
  | 'TransportationId'
  | 'InvoiceId'
  | 'OrderId'
  | 'QuoteId'
  | 'LoadBoardId';

export const IDENTITY_SEED_KEYS: IdentitySeedKey[] = [
  'ShipmentId',
  'TransportationId',
  'InvoiceId',
  'OrderId',
  'QuoteId',
  'LoadBoardId'
];

export const IDENTITY_LABELS: Record<IdentitySeedKey, string> = {
  ShipmentId: 'Shipment ID',
  TransportationId: 'Transportation ID',
  InvoiceId: 'Invoice ID',
  OrderId: 'Order ID',
  QuoteId: 'Quote ID',
  LoadBoardId: 'Load Board ID'
};

export const DEFAULT_SEED = 1000;

export type PatternTypeValue =
  | 'NumberFormat'
  | 'NumberWithPrefixOrSuffixFormat'
  | 'RandomNumberFormat'
  | 'PickUpDateFormat'
  | 'CreatedDateFormat'
  | 'InvoiceDateFormat';

export const PATTERN_TYPE_OPTIONS: PatternTypeValue[] = [
  'NumberFormat',
  'NumberWithPrefixOrSuffixFormat',
  'RandomNumberFormat',
  'PickUpDateFormat',
  'CreatedDateFormat',
  'InvoiceDateFormat'
];

export type IdentitySeeds = Partial<Record<IdentitySeedKey, number>>;

export const IDENTITY_PATTERN_KEYS: Record<IdentitySeedKey, string> = {
  ShipmentId: 'shipmentIdPattern',
  TransportationId: 'transportationIdPattern',
  InvoiceId: 'invoiceIdPattern',
  OrderId: 'orderIdPattern',
  QuoteId: 'quoteIdPattern',
  LoadBoardId: 'loadBoardIdPattern'
};

export interface IdentityPatterns {
  tenantId?: string;
  ownerId?: string;
  shipmentIdPattern?: string;
  transportationIdPattern?: string;
  invoiceIdPattern?: string;
  locationDisplayIdPattern?: string;
  orderIdPattern?: string;
  quoteIdPattern?: string;
  loadBoardIdPattern?: string;
}

export interface IdentityExample {
  name: string;
  description: string;
  template: string;
}

export const IDENTITY_EXAMPLES: IdentityExample[] = [
  {
    name: 'Sequential only',
    description: 'Plain incrementing number, e.g. 1001, 1002, 1003.',
    template: '{ID}'
  },
  {
    name: 'Date + sequential',
    description: 'Pickup date prefix followed by an incrementing number, e.g. 20260427-1001.',
    template: '{PICKUPDATE:yyyyMMdd}-{ID}'
  },
  {
    name: 'Sequential + random',
    description: 'Incrementing number with a 6-character random suffix, e.g. 1001-A7B3D2.',
    template: '{ID}-{RANDOM[6]}'
  }
];

export interface TenantDetails {
  id: string;
  name: string;
  country: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  phoneNumber: string | null;
  email: string | null;
  notes: string | null;
  active: boolean;
  identitySeeds: IdentitySeeds;
  identityPatterns: IdentityPatterns;
  carrierPortalUrl: string | null;
  customerPortalUrl: string | null;
}

export interface CreateTenantRequest {
  id?: string;
  name: string;
  country: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  phoneNumber: string;
  notes: string;
  ownerEmail: string;
  ownerPassword: string;
  ownerFirstName: string;
  ownerLastName: string;
  identitySeeds: IdentitySeeds;
  identityPatterns: IdentityPatterns;
  carrierPortalUrl: string;
  customerPortalUrl: string;
}

export interface UpdateTenantRequest {
  name: string;
  country: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  phoneNumber: string;
  email: string;
  notes: string;
  /** Blank clears the tenant's override so TMS falls back to its default portal link. */
  carrierPortalUrl: string;
  customerPortalUrl: string;
}
